import RelativeSumGameAnsweringBlock from "./RelativeSumGameAnsweringBlock";
import RelativeSumGameKeyboard from "./RelativeSumGameKeyboard";
import GamesLeaveDialog from "../../../dialogs/games/GamesLeaveDialog";
import {internalRoutes} from "../../../../constants/internalRoutes";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import GamesLeaveButton from "../../../buttons/games/GamesLeaveButton";
import GamesIndicators from "../GamesIndicators";

export default function RelativeSumGameContent({currentQuestion, currentScore, userSign, userAnswer, gameTimeLeft, onKeyPressed}) {
    // Used in MultiplicationGameScreen to handle core game
    // content made of top bar, answering block and
    // keyboard

    // PROPERTIES
    // ---- Navigation
    const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false)
    let navigate = useNavigate();

    // BUILD
    return (
        <div className={"h-[100svh] w-full flex justify-between items-start p-[24px]"}>
            {/** MODAL */}
            <GamesLeaveDialog open={isLeaveModalOpen}
                              handleClose={() => setIsLeaveModalOpen(false)}
                              leave={() => navigate(internalRoutes.games)} />
            {/** CONTENT */}
            <GamesIndicators currentScore={currentScore}
                             gameTimeLeft={gameTimeLeft} />
            <div className={"w-[400px] h-full flex flex-col justify-center items-center"}>
                <RelativeSumGameAnsweringBlock
                    currentQuestion={currentQuestion}
                    userSign={userSign}
                    userAnswer={userAnswer} />
                <RelativeSumGameKeyboard
                    userSign={userSign}
                    userAnswer={userAnswer}
                    onKeyPressed={onKeyPressed} />
            </div>
            <GamesLeaveButton onButtonPressed={() => setIsLeaveModalOpen(true)} />
        </div>
    );
}